var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclusivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-.02 0h32v32h-32z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.15 14.49a1.88 1.88 0 0 1-.92-.23L9 13.08l-2.27 1.18a2 2 0 0 1-2.86-2.08l.42-2.5-1.81-1.77a2 2 0 0 1 1.09-3.37l2.51-.36L7.21 1.9A2 2 0 0 1 9 .8a2 2 0 0 1 1.77 1.1l1.12 2.28 2.52.36a2 2 0 0 1 1.09 3.37l-1.84 1.77.43 2.5a1.94 1.94 0 0 1-.79 1.93 1.89 1.89 0 0 1-1.15.38ZM9 2.78 7.41 6l-3.55.52L6.44 9l-.6 3.54L9 10.82l3.18 1.67L11.51 9l2.57-2.51L10.54 6ZM12.15 30.47a2 2 0 0 1-.92-.23L9 29.05l-2.27 1.19a2 2 0 0 1-2.86-2.08l.42-2.51-1.81-1.77a1.93 1.93 0 0 1-.5-2 2 2 0 0 1 1.59-1.35l2.51-.36 1.13-2.28A2 2 0 0 1 9 16.77a2 2 0 0 1 1.77 1.1l1.12 2.28 2.52.36a2 2 0 0 1 1.09 3.37l-1.82 1.77.43 2.51a2 2 0 0 1-1.94 2.31ZM9 18.75 7.41 22l-3.55.51L6.44 25l-.6 3.55L9 26.79l3.18 1.68-.67-3.47 2.57-2.5-3.54-.5Z",
    fill: "#000000",
    className: "fill-02a0e1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.85 11.21 25.21 14l3 .44a1 1 0 0 1 .54 1.66l-2.16 2.1.52 3a1 1 0 0 1-1.42 1L23 20.82l-2.72 1.43a1 1 0 0 1-1.41-1l.52-3-2.19-2.14a1 1 0 0 1 .53-1.66l3-.44 1.36-2.75a1 1 0 0 1 1.76-.05Z",
    fill: "#050505",
    className: "fill-bdeeff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.81 23.36a2 2 0 0 1-1.16-.36 2 2 0 0 1-.78-1.93l.43-2.5-1.82-1.78a2 2 0 0 1 1.09-3.36l2.52-.43 1.12-2.28a2 2 0 0 1 3.54 0L25.87 13l2.52.37A2 2 0 0 1 30 14.75a2 2 0 0 1-.5 2l-1.82 1.78.43 2.5a2 2 0 0 1-.8 1.97 2 2 0 0 1-2.08.15L23 22l-2.25 1.18a2 2 0 0 1-.94.18ZM23 11.65l-1.54 3.22-3.55.52 2.59 2.46-.61 3.54 3.11-1.7 3.18 1.67-.65-3.51 2.58-2.51-3.55-.47Z",
    fill: "#000000",
    className: "fill-02a0e1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusivo);
export default __webpack_public_path__ + "static/media/exclusivo.3805fdb16f0c740d837f01d6da2468fd.svg";
export { ForwardRef as ReactComponent };